import {
  CreateReimbursableTaxonomyMappingDocument,
  CreateReimbursableTaxonomyMappingMutationVariables,
  ReimbursableSupplementTaxonomiesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useCreateReimbursableSupplementMapping = () => {
  const [createReimbursableSupplementMapping, { loading }] = useMutation(
    CreateReimbursableTaxonomyMappingDocument,
    {
      extractorFn: (data) => data.payrollMutations.createPayrollReimbursableSupplementTaxonomy,
      refetchQueries: [ReimbursableSupplementTaxonomiesDocument],
    }
  )

  return {
    loading,
    create(variables: CreateReimbursableTaxonomyMappingMutationVariables) {
      return createReimbursableSupplementMapping({
        variables,
      })
    },
  }
}

export default useCreateReimbursableSupplementMapping
